module.exports = __webpack_public_path__ + "assets/AI_LLM_light.png";